import React, { useEffect, useContext } from "react";
import { Route, RouteProps, matchPath } from "react-router-dom";
import { US_English_Locale } from "common/constants/GlobalValues";
import useSettingsStore from "common/store/SettingsStore";
import { LanguageContext } from "common/contexts/LanguageContext";
import LanguageStore from "common/store/LanguageStore";
import useLinkStore from "common/store/LinksStore";
import LoadingSpinnerBackdrop from "../progress/LoadingSpinner";

interface LocalizedRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  desc: string;
}

const LocalizedRoute: React.FC<LocalizedRouteProps> = ({ component: Component, desc, path, ...rest }) => {
  const { selectedLanguageLocale, updateSelectedLanguageLocale } = useContext(LanguageContext);
  const { settings, fetchSettings } = useSettingsStore();
  const { loading: loadingLanguages } = LanguageStore();
  const { fetchLinks, loading: loadingLinks, locale } = useLinkStore();

  useEffect(() => {
    console.log(`LocalizedRoute - ${desc}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array ensures it runs only once on mount

  useEffect(() => {
    if (settings.apiBaseUrl === "") {
      fetchSettings();
    }
  }, [settings, fetchSettings]);

  useEffect(() => {
    if (settings.apiBaseUrl !== "" && loadingLanguages === false) {
      const match = matchPath(window.location.pathname, { path: `/:locale?/:path*` });
      const locale = ((match?.params as { locale?: string })?.locale || US_English_Locale).toLowerCase();

      if (selectedLanguageLocale === "" || selectedLanguageLocale !== locale) {
        (async () => {
            const response = await updateSelectedLanguageLocale(settings.apiBaseUrl, locale);
            if (response !== locale) {
              const redirectPath = window.location.pathname.replace(locale, response);
              console.log(`replacing path to be ${redirectPath}`)
              window.history.replaceState(null, '', redirectPath);
            }
          })();
      }
    }
  });

  useEffect(() => {
    if (settings.apiBaseUrl !== "" && selectedLanguageLocale !== "" && locale !== selectedLanguageLocale) {
      fetchLinks(settings.apiBaseUrl, selectedLanguageLocale);
      console.log(`effect fetchLinks: ${selectedLanguageLocale} using baseURL: ${settings.apiBaseUrl}`);
    }
  }, [selectedLanguageLocale, fetchLinks, settings, locale]);

  return (
    <Route
      path={path}
      {...rest}
      render={(props) => (loadingLanguages || loadingLinks ? <LoadingSpinnerBackdrop /> : <Component {...props} />)}
    />
  );
};

export default LocalizedRoute;
